import * as React from "react";
import SvgSplitScreen from "../components/SvgSplitScreen";
import settings from "../styles/global/settings";
import Layout from "../components/Layout/Layout";
import PropTypes from "prop-types";
import Image from "../svg/food.svg";
import { SCREENS } from "../helpers/screen-names-helper";

const FoodCompleteScreen = ({
  onClick,
  onBackClick,
}: PropTypes.InferProps<typeof FoodCompleteScreen.propTypes>): JSX.Element => {
  const buttons = [
    {
      title: `Continue`,
      onClick: () => onClick(),
      showBack: true,
      onBackClick: () => onBackClick(),
    },
  ];
  return (
    <Layout
      buttons={buttons}
      backgroundColor={settings.color.path}
      segmentTitle={SCREENS.FoodPreferencesCompleteScreen}
    >
      <SvgSplitScreen
        backgroundColor={settings.color.primary_4}
        svg={<Image />}
      >
        <h4>Nice one! We’ve got your food preferences</h4>
        <p>Now, we’ll just ask a couple more questions about your lifestyle.</p>
      </SvgSplitScreen>
    </Layout>
  );
};

FoodCompleteScreen.propTypes = {
  onClick: PropTypes.func,
  onBackClick: PropTypes.func,
};

export default FoodCompleteScreen;
